import Quill from 'quill';
import { ImageResize } from 'quill-image-resize-module-ts';


// Quill 에디터의 기본 설정
export const defaultModules = {
    
    toolbar: [
      // [{ 'header': [
      //   { '1': '제목 1' },
      //   { '2': '제목 2' },
      //   { '3': '제목 3' },
      //   { false: '본문' }
      // ] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false // 붙여넣기 시 서식 유지
    }
  };

  
  // Quill 에디터 스타일 설정
  export const defaultStyle = {
    '.ql-container': {
      minHeight: '150px',
      fontSize: '16px',
      borderRadius: '0 0 4px 4px',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      borderTop: 0
    },
    '.ql-editor': {
      minHeight: '150px',
      '&.ql-blank::before': {
        content: 'attr(data-placeholder)',
        color: 'rgba(0, 0, 0, 0.6)',
        fontStyle: 'normal',
        left: '12px',                      // 왼쪽 패딩 맞춤
        right: '12px',                     // 오른쪽 패딩 맞춤
        position: 'absolute'    
      }
    },
    '.ql-toolbar': {
      borderRadius: '4px 4px 0 0',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      //height: '40px',
      //minHeight: '40px',
      padding: '4px 8px',
      backgroundColor: '#f5f5f5'  // 툴바 배경색
    }
  };

  
  // 커스텀 폰트가 필요한 경우의 설정
//   export const fontModules = {
//     ...defaultModules,
//     toolbar: [
//       [{ 'font': ['Arial', 'Courier', '나눔고딕', '맑은고딕'] }],
//       ...defaultModules.toolbar
//     ]
//   };

export const fontModules = {
    ...defaultModules,
    toolbar: [
      [{ 
        'font': [
          false,  // 기본값 추가
          '맑은고딕',
          '나눔고딕',
          '나눔명조',
          '돋움체',
          '굴림체',
          '바탕체'
        ] 
      }],

      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    //   ['link'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false
    }
  };
  
  // 폰트 관련 포맷
  export const fontFormats = [
    'font',
    'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'align',
    'list', 'bullet',
    'link'
  ];
  
  // 폰트 스타일 설정
  export const fontStyle = {
    ...defaultStyle,
    //'.ql-snow .ql-picker.ql-header': {
    //  '& .ql-picker-label': {
    //    '&::before': {
    //      content: '"본문"'
    //    },
    //    '&[data-value]:not([data-value="false"])::before': {
    //      content: 'attr(data-value)'
    //    }
    //  },
    //  '& .ql-picker-item': {
    //    '&::before': {
    //      content: 'attr(data-value)'
    //    },
    //    '&[data-value="false"]::before': {
    //      content: '"본문"'
    //    }
    //  }
    // },
  
     '.ql-snow .ql-picker.ql-header': {
       '& .ql-picker-label': {
         '&::before': {
           content: '"본문"'
         },
         '&[data-value="1"]::before': {
           content: '"제목 1"'
         },
         '&[data-value="2"]::before': {
           content: '"제목 2"'
         },
         '&[data-value="3"]::before': {
           content: '"제목 3"'
         },
         '&[data-value="false"]::before': {
           content: '"본문"'
         }
       },

       '& .ql-picker-item': {
         '&[data-value="1"]::before': {
           content: '"제목 1"'
         },
         '&[data-value="2"]::before': {
           content: '"제목 2"'
         },
         '&[data-value="3"]::before': {
           content: '"제목 3"'
         },
         '&[data-value="false"]::before': {
           content: '"본문"'
         }
       }
      },

      //   '& .ql-picker-item': {
      //   '&::before': {
      //     content: 'attr(data-value)'
      //   },
      //   '&[data-value="1"]::before': {
      //     content: '"제목 1"'
      //   },
      //   '&[data-value="2"]::before': {
      //     content: '"제목 2"'
      //   },
      //   '&[data-value="3"]::before': {
      //     content: '"제목 3"'
      //   },
      //   '&[data-value="false"]::before': {
      //     content: '"본문"'
      //   }
      // }

    '.ql-snow .ql-picker.ql-font': {
      '& .ql-picker-label': {
        '&::before': {
          content: '"글꼴"'
        },
        '&[data-value]:not([data-value="false"])::before': {
          content: 'attr(data-value)'
        }
      },
      '& .ql-picker-item': {
        '&::before': {
          content: 'attr(data-value)'
        },
        // '&[data-value="false"]::before': {
        //   content: '"글꼴"'
        // }
      }
    },
    '.ql-snow .ql-picker.ql-size': {
      '& .ql-picker-label': {
        '&::before': {
          content: '"크기"'
        },
        '&[data-value]:not([data-value="false"])::before': {
          content: 'attr(data-value)'
        }
      },
      '& .ql-picker-item': {
        '&::before': {
          content: 'attr(data-value)'
        },
        // '&[data-value="false"]::before': {
        //   content: '"크기"'
        // }
      }
    },
    // 폰트 패밀리 적용
    '.ql-font-맑은고딕': {
      fontFamily: '"맑은고딕", "Malgun Gothic", sans-serif'
    },
    '.ql-font-나눔고딕': {
      fontFamily: '"나눔고딕", "NanumGothic", sans-serif'
    },
    '.ql-font-나눔명조': {
      fontFamily: '"나눔명조", "NanumMyeongjo", serif'
    },
    '.ql-font-돋움체': {
      fontFamily: '"돋움체", "DotumChe", sans-serif'
    },
    '.ql-font-굴림체': {
      fontFamily: '"굴림체", "GulimChe", sans-serif'
    },
    '.ql-font-바탕체': {
      fontFamily: '"바탕체", "BatangChe", serif'
    },
    // '.ql-font-arial': {
    //   fontFamily: 'Arial, sans-serif'
    // },
    // '.ql-font-courier-new': {
    //   fontFamily: '"Courier New", Courier, monospace'
    // }
  };
  
   // 공지사항용 Quill 설정
   export const createNoticeModules = (imageHandler) => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }],
        //[{ 'header': [ { '1': '제목 1' }, { '2': '제목 2' },  { '3': '제목 3' }, { false: '본문' }] }],
        [{ 
          'font': [
            false,  // 기본값 추가
            '맑은고딕',
            '나눔고딕',
            '나눔명조',
            '돋움체',
            '굴림체',
            '바탕체'
          ] 
        }],
        [{ 
          'size': [
            false,  // 기본값 추가
            '8px',
            '10px',
            '12px',
            '14px',
            '16px',
            '18px',
            '20px'
          ]
        }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link', 'image'],
        ['code-block']
      ],
      handlers: {
        image: imageHandler
      }
    },
    history: {
        delay: 500,
        maxStack: 10
    },
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          shiftKey: false,
          handler: function(range, context) {
            const Delta = Quill.import('delta');
            const formats = this.quill.getFormat(range.index);
            const delta = new Delta()
              .retain(range.index)
              .insert('\n', formats);
            this.quill.updateContents(delta, 'user');
            this.quill.setSelection(range.index + 1, 0);
            return true;  // 이벤트 전파 중단
          }
        },
        // // 마침표 입력 시 커서 위치 조정을 위한 바인딩 추가
        // period: {
        //   key: 190, // 마침표(.) 키코드
        //   handler: function(range, context) {
        //     // 현재 위치의 텍스트가 한글인지 확인
        //     const [leaf] = this.quill.getLeaf(range.index);
        //     const isKorean = /[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uD7B0-\uD7FF]/.test(leaf.text);
            
        //     if (isKorean) {
        //       // 한글 입력 후 마침표인 경우 마침표를 직접 삽입
        //       const Delta = Quill.import('delta');
        //       const formats = this.quill.getFormat(range.index);
        //       const delta = new Delta()
        //         .retain(range.index)
        //         .insert('.', formats);
        //       this.quill.updateContents(delta, 'user');
        //       this.quill.setSelection(range.index + 1, 0);
        //       return true;  // 기본 마침표 입력 방지
        //     }
            
        //     // 한글이 아닌 경우 기본 동작 허용
        //     return false;
        //   }
        // }
      }
    },
    clipboard: {
      matchVisual: false,  // 붙여넣기 시 서식 유지
    /*  
      matchers: [
        ['p', (node, delta) => {
          const Delta = Quill.import('delta');
          const text = node.textContent;
          if (text.trim() === '') {
            return delta.compose(new Delta().retain(delta.length(), { 'whitespace': 'preserve' }));
          }
          return delta;
        }],
        ['img', (node, delta) => {
          //console.log("Clipboard matcher called for image:", {
          //  node,
          //  delta
          //});
          
          const Delta = Quill.import('delta');

          const width = node.getAttribute('width');
          const style = node.getAttribute('style');
          const src = node.getAttribute('src');
          
          //console.log("Image attributes in clipboard matcher:", {
          //  width,
          //  style,
          //  src
          //});

          // 이미지 속성이 있는 경우에만 Delta에 추가
          const attributes = {};
          if (width) attributes.width = width;
          if (style) attributes.style = style;

          const imageDelta = new Delta().insert({ 
            image: src 
          }, Object.keys(attributes).length > 0 ? attributes : undefined);

          //console.log("Final image delta:", imageDelta);
          
          return imageDelta;
          
          // const src = node.getAttribute('src');
          
          // // 이미지 속성을 포함한 Delta 생성
          // const imageDelta = new Delta().insert({ 
          //   image: src 
          // }, { 
          //   width: width,
          //   style: style
          // });
          
          // return imageDelta;
        }]
      ]
      */
      // matchers: [
      //   ['img', (node, delta) => {
      //     // 이미지 노드의 모든 속성 유지
      //     const Delta = Quill.import('delta');
      //     return delta.compose(new Delta().retain(delta.length(), { 
      //       'width': node.getAttribute('width'),
      //       'style': node.getAttribute('style')
      //     }));
      //   }]
      // ]
    },
    imageResize: {
      modules: ['Resize', 'DisplaySize', 'Toolbar'],
      displayStyles: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white'
      },
      toolbarStyles: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white'
      },
      toolbarButtonStyles: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white'
      },
      toolbarHandleStyles: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white'
      },
      // 리사이징 설정 추가
      handleStyles: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white'
      },
      displaySize: true,
      toolbar: {
        display: ['resize', 'delete'],
        position: 'top'
      },
      imageHandler: {
        upload: imageHandler
      },
    }
  });

  // 공지사항용 포맷 설정
  export const noticeFormats = [
    'header',
    'font',
    'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'align',
    'list', 'bullet',
    'link',
    'image',
    'code-block'
  ];

  // Quill에 폰트 등록
  export const registerFonts = (Quill) => {
    const Font = Quill.import('formats/font');
    Font.whitelist = [
      '맑은고딕',
      '바탕체',
      '굴림체',
      '돋움체',
      '나눔고딕',
      '나눔명조',
    ];
    Quill.register(Font, true);
  };

  // 이미지 포맷 커스텀
  class CustomImageFormat extends Quill.import('formats/image') {
    static formats(node, delta) {
      // delta가 undefined인 경우 처리
      if (!delta) {
        const Delta = Quill.import('delta');
        console.log("Delta is undefined, creating new Delta");
        delta = new Delta();
      }
  
      // 이미지 속성 가져오기
      const width = node.getAttribute('width');
      const style = node.getAttribute('style');
      const src = node.getAttribute('src');
      
      //console.log("CustomImageFormat.formats called with:", { 
      //  node, 
      //  delta,
      //  nodeAttributes: { width, style, src }
      //});
      
      // 기본 포맷 가져오기
      const formats = super.formats(node, delta);
      
      // 이미지 속성 로깅
      //console.log("Image node attributes:", {
      //  width,
      //  style,
      //  src
      //});
  
      // 속성이 있는 경우에만 추가
      if (width) {
        formats.width = width;
      }
      if (style) {
        formats.style = style;
      }
  
      // 최종 포맷 로깅
      //console.log("Final formats:", formats);
      
      return formats;
    }
  
    // 이미지 속성 보존을 위한 메서드 수정
    static value(node) {
      const src = node.getAttribute('src');
      const width = node.getAttribute('width');
      const style = node.getAttribute('style');
      
      // 이미지 URL만 반환
      return src;
    }
  }

  export const registerNotice = () => {
    const Font = Quill.import('formats/font');
    Font.whitelist = [
      '맑은고딕',
      '바탕체',
      '굴림체',
      '돋움체',
      '나눔고딕',
      '나눔명조',
    ];
    Quill.register(Font, true);

    // Header 포맷 등록
    const Header = Quill.import('formats/header');
    // Header.whitelist = [
    //   { '1': '제목 1' },
    //   { '2': '제목 2' },
    //   { '3': '제목 3' },
    //   { false: '본문' }
    // ];
    Quill.register(Header, true);

    // Size 포맷 등록
    const Size = Quill.import('attributors/style/size');
    Size.whitelist = [
      '8px',
      '10px',
      '12px',
      '14px',
      '16px',
      '18px',
      '20px'
    ];
    Quill.register(Size, true);

    // ImageResize 모듈 등록
    if (!Quill.imports['modules/imageResize']) {
      Quill.register('modules/imageResize', ImageResize);
    }


    

    // // 이미지 핸들러 등록
    const ImageFormat = Quill.import('formats/image');
    ImageFormat.sanitize = (url) => url;
    // 이미지 스타일 속성 허용
    ImageFormat.whitelist = ['style', 'width', 'height'];
    Quill.register(ImageFormat, true);

    // 커스텀 이미지 포맷 등록
    // if (!isImageFormatRegistered) {
    //   console.log("Registering custom image format");
    //   Quill.register({
    //     'formats/image': CustomImageFormat
    //   }, true); // true를 추가하여 강제 재등록
    //   isImageFormatRegistered = true;
    // }

    //const ImageHandler = Quill.import('modules/imageHandler');
    //Quill.register('modules/imageHandler', ImageHandler);
  };

  // 서명용 작은 스타일 (fontStyle 상속)
  export const smallStyle = {
    ...fontStyle,
    '& .ql-container': {
      ...defaultStyle['& .ql-container'],
      height: '130px',      // 높이만 변경
      minHeight: '100px'    // 최소 높이도 변경
    },
    '& .ql-editor': {
      ...defaultStyle['& .ql-editor'],
      height: '130px',      // 높이만 변경
      minHeight: '100px'    // 최소 높이도 변경
    }
  };

  export const noticeStyle = {
    ...fontStyle,
    '& .ql-container': {
      ...defaultStyle['& .ql-container'],
      height: '350px',
      minHeight: '300px'
    },
    '& .ql-editor': {
      ...defaultStyle['& .ql-editor'],
      height: '350px',
      minHeight: '300px'
    }
  };
 
 

  // 툴바 한글화
  export const toolbarOptions = {
    'bold': '굵게',
    'italic': '기울임',
    'underline': '밑줄',
    'strike': '취소선',
    'color': '글자색',
    'background': '배경색',
    'align': '정렬',
    'list': '목록',
    'link': '링크',
    'image': '이미지',
    'clean': '서식 지우기',
    'ordered': '번호 매기기',
    'bullet': '글머리 기호',
    'font': '글꼴',
    'size': '글자 크기'
  };

  // 기본 noticeModules 설정
  export const noticeModules = createNoticeModules(() => {});